import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import {
  LoyaltyStatusResponseStatusEnum,
  useLoyaltyApi,
} from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { useNotification } from '@packages/shared/src/providers/NotificationProvider/useNotification';
import { defineMessages, useIntl } from 'react-intl';
import useSWR from 'swr';

const messages = defineMessages({
  ErrorMessage: {
    id: 'PaybackPage.ErrorMessage',
    defaultMessage:
      'Entschuldige, irgendetwas ist schief gelaufen. Probiere es später noch einmal.',
  },
});

export const usePaybackConnectionStatus = () => {
  const loyaltyApi = useLoyaltyApi();
  const { loggedIn } = useLoginState();
  const { locale, formatMessage } = useIntl();
  const { addNotification } = useNotification();
  const { data, isLoading } = useSWR(
    loyaltyApi && loggedIn ? 'getLoyaltyConnectionStatus' : null,
    () =>
      loyaltyApi?.getLoyaltyConnectionStatus({
        ecLocale: locale,
      }),
    {
      revalidateOnFocus: false,
      onSuccess: (callbackData) => {
        if (callbackData?.errors) {
          addNotification({
            severity: 'error',
            message: callbackData.errors.elements[0].description,
            duration: 5000,
            onClose: () => {},
          });
        }
        if (callbackData?.warnings) {
          addNotification({
            severity: 'warning',
            message: callbackData.warnings.elements[0].description,
            duration: 5000,
            onClose: () => {},
          });
        }
      },
      onError: () =>
        addNotification({
          message: formatMessage(messages.ErrorMessage),
          severity: 'error',
          duration: 5000,
        }),
    },
  );

  const status = {
    isOffline: !data?.status,
    isDisconnected:
      !loyaltyApi || !loggedIn || data?.status === LoyaltyStatusResponseStatusEnum.NoConnection,
    isInactive: data?.status === LoyaltyStatusResponseStatusEnum.ConnectionInactive,
    isEstablished: data?.status === LoyaltyStatusResponseStatusEnum.ConnectionEstablished,
    isReauthenticationNeeded:
      data?.status === LoyaltyStatusResponseStatusEnum.ReauthenticationNeeded,
    isLoading,
  };

  return {
    ...status,
    isConnected:
      !status.isLoading &&
      !status.isOffline &&
      !status.isDisconnected &&
      !status.isInactive &&
      !status.isReauthenticationNeeded,
  };
};
